// extracted by mini-css-extract-plugin
export default {"padd":"UserRating_padd__WeJU5","rate":"UserRating_rate__2HOBz"};